import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const SetSerialNr = createAsyncThunk(
  '/SetSerialNr',
  async (data) => {
    const response = await axios.post('/SetSerialNr',data)
    return response.data
  }
)

const serialNumberSlice = createSlice({
  name: 'serialNumber',
  initialState: {
    loading: false,
    error: ''
  },
  reducers: {    
  },
  extraReducers: {
  }
});

export const serialNumberActions = serialNumberSlice.actions;

export default serialNumberSlice;
